import React, {Component} from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'

class SelectCabinWidth extends Component {

  handleChange = (e) => {
    this.props.actions.changeSelectCabinWidth({
      selectCabinWidth: e.target.value,
    })
  }

  render() {
    const {  payload } = this.props.systemLabelMastersApi
    if (!payload) {return null}
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    const {selectCabinWidth} = this.props
    return (
      <div className='searchArea__item'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.LIST_SEARCH.CABIN_WIDTH}</h3>
        <p className="radio radio-3 searchArea__item__inner searchArea__item__cabinWidth" >
          <input
            className='radio'
            checked={selectCabinWidth == ''}
            type='radio'
            name='select_cabin_width'
            value=''
            id='cabin_width_all'
            onChange={this.handleChange}
          />
          <label htmlFor='cabin_width_all'>{TRUCKERS.LANG.ITEM.LIST_SEARCH.ALL}</label>
          {
            systemLabelMasterCollection.getValueList('item','cabin_width').map(i => {
              return(
                <React.Fragment key={i.get('label_key')}>
                  <input
                    className='radio'
                    checked={i.get('label_key')==selectCabinWidth}
                    type='radio'
                    name='select_cabin_width'
                    value={i.get('label_key')}
                    id={i.get('label_key')}
                    onChange={this.handleChange}
                  />
                  <label htmlFor={i.get('label_key')}>{i.getValueI18n()}</label>
                </React.Fragment>
              )
            })
          }
        </p>
      </div>
    )
  }
}
export default SelectCabinWidth
